"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _flowbiteReact = require("flowbite-react");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const CustomModal = _ref => {
  let {
    modalBtnName,
    modalTitle,
    modalDesc,
    actionBtnHref,
    actionBtn
  } = _ref;
  const [openModal, setOpenModal] = (0, _react.useState)();
  const props = {
    openModal,
    setOpenModal
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      onClick: () => props.setOpenModal("default"),
      className: "secondary-btn-sml inline-flex items-center port:!w-[100px] port:!h-[33px]",
      children: modalBtnName
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Modal, {
      size: "lg",
      show: props.openModal === "default",
      onClose: () => props.setOpenModal(undefined),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_flowbiteReact.Modal.Header, {
        className: "!p-3 !pb-0 !border-0",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
          width: "24",
          height: "24",
          viewBox: "0 0 24 24",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            "clip-path": "url(#clip0_964_9699)",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("mask", {
              id: "mask0_964_9699",
              maskUnits: "userSpaceOnUse",
              x: "0",
              y: "0",
              width: "24",
              height: "24",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "#D9D9D9"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
              mask: "url(#mask0_964_9699)",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                d: "M12 17C12.2833 17 12.5208 16.9042 12.7125 16.7125C12.9042 16.5208 13 16.2833 13 16C13 15.7167 12.9042 15.4792 12.7125 15.2875C12.5208 15.0958 12.2833 15 12 15C11.7167 15 11.4792 15.0958 11.2875 15.2875C11.0958 15.4792 11 15.7167 11 16C11 16.2833 11.0958 16.5208 11.2875 16.7125C11.4792 16.9042 11.7167 17 12 17ZM11 13H13V7H11V13ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z",
                fill: "#0576DB"
              })
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("defs", {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)("clipPath", {
              id: "clip0_964_9699",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "white"
              })
            })
          })]
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_flowbiteReact.Modal.Body, {
        className: "block m-auto",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "text-center max-w-[380px]",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h4", {
            children: modalTitle
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
            className: "mt-6 ",
            children: modalDesc
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "flex justify-center mt-8",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
            href: actionBtnHref,
            onClick: () => props.setOpenModal(undefined),
            className: "primary-btn-sml inline-flex items-center",
            children: actionBtn
          })
        })]
      })]
    })]
  });
};
var _default = CustomModal;
exports.default = _default;